import { useTheme } from "@/components/ThemeProvider";

const LOGOS = {
  light: {
    favicon: "https://storage.googleapis.com/hobbes-assets/Favicon_Dark.svg",
    fullLogo: "https://storage.googleapis.com/hobbes-assets/FullLogo_Dark.svg",
  },
  dark: {
    favicon: "https://storage.googleapis.com/hobbes-assets/Favicon.svg",
    fullLogo: "https://storage.googleapis.com/hobbes-assets/FullLogo2026.svg",
  },
};

export function useThemeLogos() {
  const { theme } = useTheme();

  const isDark = theme === 'dark' ||
    (theme === 'system' && typeof window !== 'undefined' &&
     window.matchMedia('(prefers-color-scheme: dark)').matches);

  return isDark ? LOGOS.dark : LOGOS.light;
}
